<script>
import axios from "axios";
import Vue from 'vue';

export default new Vue({
    data(){
        return {
            images: [],
            imagesPromise : null
        }
    },
    methods: {
        async getImages(no){
            await this.imagesPromise;
            return this.images[no];
        },
    },
    created(){
        // console.log("Image service created");
        this.imagesPromise = new Promise((resolve)=>{
            axios.get("/images.json?2").then((res)=>{
                this.images = res.data;
                resolve();
            });
        });
    }
})
</script>